/**
 * API client de Kanbans (Fase 6).
 *
 *   GET     /api/kanbans                          (lista compacta)
 *   POST    /api/kanbans                          (cria board + estagios)
 *   GET     /api/kanbans/{id}                     (detalhe)
 *   PATCH   /api/kanbans/{id}                     (renomear/ativar)
 *   DELETE  /api/kanbans/{id}
 *   GET     /api/kanbans/{id}/board               (estagios + cartoes embedded)
 *   POST    /api/kanbans/{id}/reordenar-estagios  body: {nova_ordem: [uuid,...]}
 *
 *   GET/POST/PATCH/DELETE  /api/kanban-estagios
 *   GET/POST/PATCH/DELETE  /api/kanban-cartoes
 *   POST   /api/kanban-cartoes/{id}/mover        body: {estagio_destino, ordem_destino?}
 */

const PREFIXO_K = "/api/kanbans";
const PREFIXO_E = "/api/kanban-estagios";
const PREFIXO_C = "/api/kanban-cartoes";

// ---------- Kanban ----------

export function listarKanbans(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.tipo) usp.set("tipo_entidade", params.tipo);
  if (params.busca) usp.set("busca", params.busca);
  if (params.ativo !== undefined) usp.set("ativo", params.ativo ? "true" : "false");
  if (params.pageSize) usp.set("page_size", params.pageSize);
  const qs = usp.toString();
  return request(`${PREFIXO_K}${qs ? `?${qs}` : ""}`);
}

export function obterKanban(request, id) {
  return request(`${PREFIXO_K}/${id}`);
}

export function obterBoard(request, id) {
  return request(`${PREFIXO_K}/${id}/board`);
}

export function criarKanban(request, dados) {
  return request(PREFIXO_K, { method: "POST", body: JSON.stringify(dados) });
}

export function atualizarKanban(request, id, dados) {
  return request(`${PREFIXO_K}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function deletarKanban(request, id) {
  return request(`${PREFIXO_K}/${id}`, { method: "DELETE" });
}

export function reordenarEstagios(request, kanbanId, novaOrdemUuids) {
  return request(`${PREFIXO_K}/${kanbanId}/reordenar-estagios`, {
    method: "POST",
    body: JSON.stringify({ nova_ordem: novaOrdemUuids }),
  });
}

// ---------- Estagio ----------

export function criarEstagio(request, dados) {
  return request(PREFIXO_E, { method: "POST", body: JSON.stringify(dados) });
}

export function atualizarEstagio(request, id, dados) {
  return request(`${PREFIXO_E}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function deletarEstagio(request, id) {
  return request(`${PREFIXO_E}/${id}`, { method: "DELETE" });
}

// ---------- Cartao ----------

export function criarCartao(request, dados) {
  return request(PREFIXO_C, { method: "POST", body: JSON.stringify(dados) });
}

export function atualizarCartao(request, id, dados) {
  return request(`${PREFIXO_C}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}

export function deletarCartao(request, id) {
  return request(`${PREFIXO_C}/${id}`, { method: "DELETE" });
}

export function moverCartao(request, id, { estagio_destino, ordem_destino } = {}) {
  const body = { estagio_destino };
  if (ordem_destino !== undefined) body.ordem_destino = ordem_destino;
  return request(`${PREFIXO_C}/${id}/mover`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
